module.exports = __webpack_public_path__ + "static/pc_service_magento-e2110084be1bddcd5143ada69770b425.jpg";